import Row from '@sdk/components/ui/spacing/Row';
import gettext from '@sdk/lang/gettext';
import { useSession } from '@sdk/session/SessionContext';

import { useCommentActions } from '@web/newsfeed/Article/ArticleComments/hooks/useCommentActions';
import { ArticleComment } from '@web/newsfeed/types/Article';

import { EditButton, EditIcon, DeleteIcon, DeleteButton } from './commentActions.styles';

type Props = {
  comment: ArticleComment;
  onEdit: (comment: ArticleComment) => void;
};

export const CommentActions = ({ comment, onEdit }: Props) => {
  const { currentUser } = useSession();
  const { pageId, articleId, id: commentId, user } = comment;
  const { deleteComment } = useCommentActions();
  const canEdit = !!user.isMe;

  return (
    <Row>
      {canEdit && (
        <EditButton onClick={() => onEdit(comment)} data-tip={gettext('Edit comment')}>
          <EditIcon />
        </EditButton>
      )}

      {(canEdit || currentUser.isManager) && (
        <DeleteButton
          onClick={() => deleteComment({ pageId, articleId, commentId })}
          data-tip={gettext('Delete comment')}>
          <DeleteIcon />
        </DeleteButton>
      )}
    </Row>
  );
};
